import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormTreeSelectField from 'components/ui/form/FormTreeSelectField';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = yup.object({
  name: yup.string().required('settings.crm.validation.name'),
  token: yup.string().required('settings.crm.validation.token'),
  crm_block_item_id: yup
    .string()
    .required('settings.crm.validation.crmBlockItemId'),
});

const TgBotSettings = (props) => {
  const { open, setOpen, refetch = () => {}, data } = props;
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      name: '',
      token: '',
      crm_block_id: '',
      crm_block_item_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const type = data?.id ? 'postUpdate' : 'post';
      submit(
        { type, contentType: 'simple' },
        values,
        '/admin/tgbot',
        values.name,
        data?.id,
        false,
        handleFinishRequest
      );
    },
  });

  useEffect(
    () => {
      if (data?.id) {
        formik.setValues({
          name: data?.name,
          token: data?.token,
          crm_block_id: data?.pipe?.crm_block_id,
          crm_block_item_id: data?.crm_block_item_id,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, open]
  );

  const handleFinishRequest = () => {
    refetch();
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{ className: '!base-border !shadow-none' }}
    >
      <DialogTitle id='alert-dialog-title'>
        {data?.id ? (
          <span>{t('settings.crm.modal.editTgBot')}</span>
        ) : (
          <span>{t('settings.crm.modal.addTgBot')}</span>
        )}
        <div className='close-btn-wrapper'>
          <IconButton variant='onlyIcon' color='primary' onClick={handleClose}>
            <i className='bi bi-x' />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent className='!max-w-[600px]'>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                duration={0}
                label={t('common.fields.simpleName')}
                fieldName='name'
                formik={formik}
              />
            </Grid>

            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                duration={0}
                label={t('common.fields.token')}
                fieldName='token'
                formik={formik}
                multiline
                rows={3}
              />
            </Grid>

            <Grid item={true} lg={12} sm={12} xs={12}>
              <div className='border border-gray-400 mt-2 p-[5px] rounded-lg [&>*]:!m-0'>
                <FormTreeSelectField
                  parentFieldName='crm_block_id'
                  childFieldName='crm_block_item_id'
                  label=''
                  childOptionField={'pipes'}
                  formik={formik}
                  parentLabel={'name'}
                  parentValue={'id'}
                  childLabel={'name'}
                  childValue={'id'}
                  variant='standard'
                  path='/crm/block'
                  size='small'
                  onChange={() => {}}
                  progress={false}
                />
              </div>
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                duration={0}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(TgBotSettings);
